/* eslint-disable no-useless-escape */
export const PHONE_INPUT_REGEX = /^(\+(\d[\d\s\(\)\-\+]*\d)?)$/;
